<template>
  <span>{{ formattedNumber }}</span>
</template>

<script setup>
import { ref, watch } from 'vue'
import gsap from 'gsap'

// eslint-disable-next-line no-undef
const props = defineProps({
  value: {
    type: Number,
    required: true
  },
  duration: {
    type: Number,
    default: 1
  },
  decimalPlaces: {
    type: Number,
    default: 0
  }
})

const currentNumber = ref(props.value)
const formattedNumber = ref(currentNumber.value.toFixed(props.decimalPlaces))

// 监听 value 的变化
watch(
  () => props.value,
  (newValue, oldValue) => {
    if (newValue !== oldValue) {
      // 终止当前动画
      gsap.killTweensOf(currentNumber)

      // 重新开始新的动画
      gsap.to(currentNumber, {
        value: newValue,
        duration: props.duration,
        ease: 'power1.inOut',
        onUpdate: () => {
          formattedNumber.value = currentNumber.value.toFixed(
            props.decimalPlaces
          )
        }
      })
    }
  }
)
</script>
